import React from "react"
import { company } from "@/config/company"
import { useTenant } from "@/contexts/TenantContext"

const Footer: React.FC = () => {
  const { tenant } = useTenant()
  return (
    <footer className="footer">
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-6">{new Date().getFullYear()} &copy; {tenant?.company || company.name}.</div>
          <div className="col-sm-6"></div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
